import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import kerstmis from './modules/kerstmis'
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    kerstmis,
  }
})
